import React from 'react';
import { Helmet } from 'react-helmet-async';
import { getMarketplaceUrl } from '../../config/platformConfig';

const DEFAULT_OG_IMAGE = 'https://revstar-media-production.s3.eu-north-1.amazonaws.com/website-assets/img/og-image.png';
const SITE_NAME = 'Revstar Marketplace';

const clampDescription = (input, max = 160) => {
  if (!input) return '';
  const cleaned = String(input).replace(/\s+/g, ' ').trim();
  if (cleaned.length <= max) return cleaned;
  return `${cleaned.slice(0, max - 1).trimEnd()}…`;
};

const marketplaceOrigin = () => {
  const raw = getMarketplaceUrl() || '';
  try {
    const url = new URL(raw);
    return `${url.protocol}//${url.host}`;
  } catch (_) {
    return raw.replace(/\/$/, '');
  }
};

export const marketplaceUrlFor = (path = '/') => {
  const origin = marketplaceOrigin();
  if (!origin) return path;
  const clean = path.startsWith('/') ? path : `/${path}`;
  return `${origin}${clean}`;
};

const MarketplaceSeo = ({
  title,
  description,
  path = '/',
  image,
  type = 'website',
  jsonLd,
  noIndex = false
}) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const canonical = marketplaceUrlFor(path);
  const ogImage = image || DEFAULT_OG_IMAGE;
  const desc = clampDescription(description);

  const jsonLdArray = Array.isArray(jsonLd) ? jsonLd : (jsonLd ? [jsonLd] : []);

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      {desc ? <meta name="description" content={desc} /> : null}
      {noIndex ? <meta name="robots" content="noindex,nofollow" /> : <meta name="robots" content="index,follow" />}
      <link rel="canonical" href={canonical} />

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      {desc ? <meta property="og:description" content={desc} /> : null}
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {desc ? <meta name="twitter:description" content={desc} /> : null}
      <meta name="twitter:image" content={ogImage} />

      {jsonLdArray.map((entry, index) => (
        <script key={`ld-${index}`} type="application/ld+json">
          {JSON.stringify(entry)}
        </script>
      ))}
    </Helmet>
  );
};

export default MarketplaceSeo;
